var _defs, _defs2, _defs3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmptyCart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3710 3710",
    style: {
      enableBackground: "new 0 0 3710 3710"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#FFFFFF"
    },
    width: 3710,
    height: 3710
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2823.415,3147.516c-218.589,70.33-295.134-160.777-824.98-296.353 c-669.783-171.383-928.38,108.32-1218.539-101.452C379.042,2459.912,336.31,1612.192,672.432,1068.94 c18.504-29.907,378.393-593.475,973.833-671.292c14.011-1.831,24.462-2.874,33.618-3.843 c88.609-9.382,637.7-58.897,1085.429,316.211c38.443,32.208,157.543,135.366,262.874,298.261 C3492.083,1725.693,3298.239,2994.746,2823.415,3147.516z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M1662.079,2057.434l230.578,191.888c0,0,141.839-82.16,154.801-212.659 c26.447-266.258,257.798-224.512,357.313-221.523c150.077,4.508,284.295-56.972,187.734-212.723 c-96.561-155.752,210.075-251.096,451.398-208.885c236.152,41.307,445.846-354.645-57.067-490.979 c-300.338-81.418-458.164,177.507-568.95,289.315c-110.786,111.807-298.345-27.401-359.529,170.895 c-52.262,169.381-29.014,343.949-176.958,367.18C1733.455,1753.174,1644.914,1843.58,1662.079,2057.434z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000104678466686982190320000007676290333237137565_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163764345499625562900000011795928098612847787_",
    gradientUnits: "userSpaceOnUse",
    x1: 3649.0815,
    y1: 158.5096,
    x2: 3051.8772,
    y2: 1855.8282,
    gradientTransform: "matrix(0.7686 0.6397 -0.6397 0.7686 483.7149 -1401.0807)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000104678466686982190320000007676290333237137565_)",
      fill: "url(#SVGID_00000163764345499625562900000011795928098612847787_)"
    },
    d: " M1662.079,2057.434l230.578,191.888c0,0,141.839-82.16,154.801-212.659c26.447-266.258,257.798-224.512,357.313-221.523 c150.077,4.508,266.606-54.063,206.924-204.632c-67.527-170.361,190.885-259.188,432.208-216.977 c236.152,41.307,445.846-354.645-57.067-490.979c-300.338-81.418-458.164,177.507-568.95,289.315 c-110.786,111.807-298.345-27.401-359.529,170.895c-52.262,169.381-29.014,343.949-176.958,367.18 C1733.455,1753.174,1644.914,1843.58,1662.079,2057.434z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000104678466686982190320000007676290333237137565_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1744.064,2161.884l5.519,3.107c1.924-3.418,195.82-344.919,490.117-625.504 c271.124-258.495,685.425-516.675,1119.46-278.693l3.045-5.552c-193.212-105.94-398.632-124.067-610.555-53.883 c-169.291,56.065-343.037,168.315-516.414,333.632C1940.286,1816.234,1745.994,2158.46,1744.064,2161.884z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M2664.359,1234.513l5.333,3.417c113.78-177.429,365.086-354.832,367.61-356.604l-3.634-5.186 C3031.132,877.92,2778.806,1056.043,2664.359,1234.513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M2806.845,1191.619c248.825,34.275,361.155,210.669,362.259,212.446l5.377-3.342 c-1.119-1.806-114.896-180.682-366.771-215.379L2806.845,1191.619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M2057.292,1733.406c245.417-184.205,604.394,19.271,607.726,21.546l3.902-4.98 c-3.058-2.542-367.833-207.472-615.429-21.63L2057.292,1733.406z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M2136.719,1634.909l5.594,2.975c91.982-172.86,16.52-407.273,15.746-409.623l-6.014,1.979 C2152.81,1232.566,2227.422,1464.464,2136.719,1634.909z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1781.276,2111.925c81.357-83.484,267.751-48.081,269.625-47.716l1.219-6.212 c-7.782-1.53-191.622-36.44-275.378,49.509L1781.276,2111.925z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#BEB8F2"
    },
    d: "M1826.106,2030.437l5.481,3.173c46.194-79.758,5.376-245.401-8.038-299.833 c-1.895-7.693-3.531-14.333-3.59-15.573l-6.329,0.209c0.058,1.751,1.132,6.168,3.77,16.879 C1830.662,1789.111,1871.02,1952.889,1826.106,2030.437z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000147185949333054950060000017282574028382488492_",
    gradientUnits: "userSpaceOnUse",
    x1: -889.4072,
    y1: 174.4042,
    x2: -268.0396,
    y2: 1807.1006,
    gradientTransform: "matrix(-0.982 -0.1887 -0.1887 0.982 1705.58 32.4287)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000147185949333054950060000017282574028382488492_)"
    },
    d: "M2065.811,1541.685 c19.96,62.504-13.509,118.335-43.509,154.975c-5.972-0.711-9.646,0.511-15.858,1.224c-56.073,6.425-80.75-3.506-136.571-6.427 c-12.015-0.629-46.276-13.93-59.907-20.338l-25.215-12.387c0,0-28.776-149.557,49.68-180.05 c78.456-30.493,68.223-177.032,71.826-255.801c2.213-48.37,17.762-70.426,21.252-88.187 c36.943-188.013-8.462-250.038,38.535-304.984c51.88-60.656,122.064-2.431,181.646-65.392 c67.279-71.097,22.958-193.074,100.129-245.861c13.23-9.05,27.04-17.977,47.419-21.907 c50.302-9.701,85.228,24.759,125.561-13.812c81.068-77.531,198.961-94.225,255.802,3.126 c56.099,96.08-47.256,260.42-267.433,375.34c-148.615,100.337-155.099,135.134-155.243,221.832 c-0.103,60.726,37.44,223.652-51.519,275.697C2113.447,1410.779,2042.992,1470.232,2065.811,1541.685z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000174594913249116719910000016433324798036402307_",
    d: "M1980.928,1740.605l-192.393-76.094 c0,0-32.56-155.336,45.896-185.829c78.457-30.493,68.223-177.031,71.827-255.801c9.778-213.721,236.066-165.855,270.583-439.49 c9.181-72.779,2.353-214.642,70.978-264.934c78.183-57.296,121.112,13.885,172.98-35.719 c81.068-77.53,198.961-94.224,255.802,3.126c56.099,96.08-47.256,260.42-267.431,375.34 c-148.617,100.337-155.099,135.134-155.245,221.831c-0.102,60.726,37.439,223.653-51.52,275.698 c-88.959,52.045-159.413,111.499-136.595,182.952C2100.531,1650.41,1980.928,1740.605,1980.928,1740.605z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000080904780121538252050000000125512355566397338_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000174594913249116719910000016433324798036402307_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000080904780121538252050000000125512355566397338_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1898.398,1697.29l-3.975-1.01c6.012-23.688,12.368-47.504,18.891-70.785 c48.309-172.372,110.959-333.997,186.215-480.387c63.768-124.04,137.456-238.902,219.017-341.396 c65.591-82.425,136.608-157.336,211.079-222.65c52.353-45.914,105.856-86.649,159.029-121.068 c9.265-6,19.076-11.617,28.565-17.05c12.642-7.238,25.714-14.722,37.594-23.171l2.376,3.343 c-12.043,8.565-25.203,16.101-37.931,23.388c-9.442,5.405-19.204,10.995-28.375,16.934 c-53.005,34.311-106.35,74.924-158.554,120.709c-74.286,65.152-145.133,139.885-210.574,222.12 c-81.393,102.283-154.934,216.917-218.579,340.717c-75.13,146.142-137.679,307.51-185.912,479.616 C1910.749,1649.85,1904.402,1673.632,1898.398,1697.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2227.693,935.05l-3.469-2.189c94-148.858,65.422-449.192,65.121-452.208l4.082-0.407 C2293.728,483.277,2322.445,785,2227.693,935.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2001.243,1374.515l-3.699-1.771c52.046-108.638,275.254-169.582,277.503-170.185l1.063,3.964 C2273.879,1207.12,2052.475,1267.574,2001.243,1374.515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1977.042,1438.708l-3.954-1.092c20.897-75.806,8.892-190.352-33.804-322.531 c-2.147-6.647-2.147-6.647-1.95-7.4l3.968,1.042l-1.984-0.521l2.026-0.259c0.092,0.459,0.902,2.968,1.843,5.877 C1986.126,1246.759,1998.151,1362.137,1977.042,1438.708z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1909.982,1654.215l-3.476-2.175c45.947-73.417,173.496-88.694,174.778-88.84l0.465,4.076 C2080.484,1567.42,1954.877,1582.48,1909.982,1654.215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M1892.206,1696.836c-6.877-69.501-33.934-139.3-82.717-213.386l3.428-2.257 c49.156,74.656,76.427,145.061,83.371,215.239L1892.206,1696.836z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2489.101,623.333l-3.339-2.38c56.875-79.85,98.117-176.922,111.669-208.82 c3.281-7.722,4.444-10.436,5.014-11.311l3.437,2.238c-0.426,0.674-2.301,5.088-4.675,10.677 C2587.61,445.738,2546.236,543.118,2489.101,623.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2377.423,739.484l-2.491-3.258c73.021-55.852,255.184-30.968,262.903-29.881l-0.573,4.062 C2635.39,710.143,2449.08,684.675,2377.423,739.484z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000062873257979653088170000014845469474514758560_",
    gradientUnits: "userSpaceOnUse",
    x1: 4237.0977,
    y1: -50.0584,
    x2: 4869.022,
    y2: 990.2523,
    gradientTransform: "matrix(-0.9926 -0.1214 -0.1214 0.9926 7047.4268 1115.4489)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FF9085"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FB6FBB"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000062873257979653088170000014845469474514758560_)"
    },
    d: "M2335.422,1440.749 c-1.132,0.342-2.266,0.68-3.402,1.016c-67.219,19.85-144.186,29.671-231.964,22.573c-17.013-2.59-34.025-5.181-51.038-7.771 c-9.525-42.241-11.022-84.121,42.832-93.745c83.634-14.945,101.852-156.953,85.434-209.803 c-20.32-65.414-64.507-218.699,64.424-243.837c107.334-20.929,180.874-12.496,203.372-145.041 c22.499-132.545,104.81-207.434,224.86-185.677c126.334,22.897,250.08-134.61,347.885-66.017 c170.419,119.522-27.798,394.625-258.517,454.515c-230.719,59.89-113.058,154.009-119.572,263.839 c-8.893,149.94-206.703,95.078-266.606,147.536C2352.84,1396.104,2341.438,1418.186,2335.422,1440.749z"
  }), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000159444464465914573040000007779402422029866907_",
    d: "M2331.907,1523.537l-277.103-33.881 c-11.346-41.2-23.11-116.084,37.046-126.834c83.634-14.946,101.852-156.952,85.434-209.804 c-20.32-65.413-64.507-218.698,64.424-243.837c107.334-20.928,180.874-12.496,203.372-145.041 c22.499-132.545,104.81-207.435,224.86-185.677c126.334,22.896,250.081-134.61,347.885-66.016 c170.419,119.521-27.798,394.623-258.517,454.514c-230.719,59.89-113.058,154.009-119.572,263.839 c-8.894,149.941-206.703,95.078-266.606,147.535C2326.171,1419.459,2326.672,1483.669,2331.907,1523.537z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000027600600504419924320000006952093080589640087_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000159444464465914573040000007779402422029866907_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      clipPath: "url(#SVGID_00000027600600504419924320000006952093080589640087_)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2206.761,1463.996l-5.75-1.879c137.46-420.363,478.261-771.953,889.407-917.565l2.019,5.702 C2683.022,695.253,2343.65,1045.379,2206.761,1463.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2301.337,1241.232l-6.008-0.706c20.335-172.616-111.589-324.577-112.924-326.092l4.539-4 C2188.296,911.967,2321.992,1065.895,2301.337,1241.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2234.156,1387.356l-4.951-3.475c101.239-144.228,421.781-128.568,425.007-128.392l-0.328,6.041 C2650.693,1261.356,2333.47,1245.871,2234.156,1387.356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2558.759,892.453l-5.233-3.039c70.252-120.854,10.212-326.628,9.598-328.692l5.796-1.729 C2569.544,561.083,2630.31,769.367,2558.759,892.453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FCFDFE"
    },
    d: "M2774.276,712.325l-2.545-5.49c144.527-66.956,347.872,3.394,349.911,4.116l-2.012,5.706 C3117.618,715.942,2916.55,646.41,2774.276,712.325z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000036246569813708875620000005107747193218542520_",
    gradientUnits: "userSpaceOnUse",
    x1: 1609.9584,
    y1: -388.2995,
    x2: 1245.5615,
    y2: 1670.041
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000036246569813708875620000005107747193218542520_)"
    },
    d: "M2200.981,1415.783 c-0.001,514.794-340.623,975.45-807.776,1034.879c-528.635,67.25-1011.117-393.75-1011.116-1038.137 C382.092,768.138,864.576,308.866,1393.211,378.01C1860.362,439.112,2200.982,900.987,2200.981,1415.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2274.131,1429.996c-0.001,515.899-340.624,977.542-807.776,1037.097 C937.721,2534.488,455.239,2072.5,455.24,1426.732C455.241,780.964,937.725,320.708,1466.36,390 C1933.511,451.233,2274.132,914.099,2274.131,1429.996z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8D8A"
    },
    d: "M1466.355,2277.138c-426.088,44.245-807.586-335.087-807.585-850.041 c0.001-514.954,381.501-892.917,807.589-847.141c385.223,41.385,672.393,421.049,672.392,849.798 S1851.579,2237.136,1466.355,2277.138z M1466.36,690.024c-368.29-34.52-693.791,294.883-693.792,737.277 c-0.001,442.393,325.499,772.966,693.789,739.769c337.356-30.409,591.603-360.228,591.604-737.462 C2057.961,1052.375,1803.716,721.643,1466.36,690.024z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8D8A"
    },
    d: "M1466.356,1978.887c-271.278,18.098-505.873-228.678-505.872-551.249 c0-322.57,234.598-568.505,505.875-549.433c254.115,17.865,449.288,264.659,449.287,551.147 C1915.646,1715.841,1720.471,1961.934,1466.356,1978.887z M1466.359,988.274c-215.565-12.201-399.666,184.711-399.667,439.555 c0,254.844,184.101,452.418,399.665,440.99c204.584-10.845,363.497-207.839,363.498-439.62 C1829.854,1197.418,1670.943,999.854,1466.359,988.274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF8D8A"
    },
    d: "M1659.63,1428.894c0,123.437-85.369,225.784-193.273,228.666 c-110.884,2.962-203.044-99.7-203.044-229.377c0.001-129.678,92.161-232.009,203.045-228.649 C1574.262,1202.804,1659.631,1305.456,1659.63,1428.894z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000119834267816891720800000016560557242668300701_",
    gradientUnits: "userSpaceOnUse",
    x1: 2623.5781,
    y1: 568.3069,
    x2: 2501.8748,
    y2: 806.2641
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#444B8C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#26264F"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000119834267816891720800000016560557242668300701_)"
    },
    d: "M2549.324,933.777 c10.27-5.186,26.777-15.257,40.497-33.514c14.693-19.551,30.389-54.074,18.156-68.427c-7.229-8.483-17.547-1.76-30.723-6.982 c-37.306-14.787-15.744-92.55-49.923-118.662c-31.267-23.888-114.246-8.414-138.051,50.86 c-19.958,49.698,11.711,105.216,45.532,123.66c18.348,10.007,30.949,6.813,64.239,20.948 C2511.58,906.979,2529.602,916.374,2549.324,933.777z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000033326708369054435450000018177225200887822473_",
    gradientUnits: "userSpaceOnUse",
    x1: 2610.8005,
    y1: 2571.8357,
    x2: 2986.7529,
    y2: 2926.7463,
    gradientTransform: "matrix(0.9873 -0.1586 0.1586 0.9873 -230.7199 205.6246)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000033326708369054435450000018177225200887822473_)"
    },
    d: "M3013.833,2478.965l4.814-8.351 c0,0,8.642-5.177,12.729,5.533c4.088,10.708,27.283,66.653,28.517,92.028c-6.084,15.183-23.304,2.323-26.856-7.998 c-3.553-10.322-15.859-48.6-15.859-48.6L3013.833,2478.965z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000106829978599574741170000000360595458506708360_",
    gradientUnits: "userSpaceOnUse",
    x1: 2362.1414,
    y1: 2236.7034,
    x2: 2734.5322,
    y2: 2091.4709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000106829978599574741170000000360595458506708360_)"
    },
    d: "M2959.077,2518.898 c7.192-0.106,14.345-0.054,21.583-0.378c13.196-0.59,26.46-1.539,39.775-2.864c-2.225-13.85-4.449-27.701-6.674-41.551 c-6.792-2.594-13.426-5.196-19.917-7.807c-3.314-1.334-6.487-2.678-9.724-4.015c-3.054-1.261-6.173-2.52-9.158-3.786 c-4.392-1.863-8.634-3.734-12.881-5.604c-1.688-0.743-3.44-1.482-5.107-2.227c-4.985-2.229-9.826-4.465-14.61-6.701 c-0.807-0.377-1.653-0.754-2.453-1.13c-5.178-2.442-10.22-4.886-15.167-7.336c-0.358-0.179-0.738-0.354-1.096-0.533 c-5.208-2.589-10.288-5.183-15.246-7.778c-0.068-0.037-0.14-0.071-0.209-0.107c-10.086-5.288-19.656-10.59-28.74-15.898l0,0 c-112.573-65.789-149.798-132.584-161.267-185.107c-32.271-147.777,125.739-242.67,84.924-402.92 c-30.755-120.76-160.573-224.162-240.509-200.046c-90.277,27.233-104.422,202.212-113.128,309.895 c-9.801,121.245-20.721,256.319,56.823,377.307c73.427,114.571,206.078,185.074,358.72,203.838 c0,0.008-0.001,0.015-0.001,0.024c3.63,0.445,7.348,0.648,11,1.035c8.851,0.938,17.688,1.917,26.659,2.509 c4.104,0.271,8.28,0.287,12.405,0.485c8.746,0.42,17.472,0.903,26.308,0.994 C2947.248,2519.255,2953.184,2518.982,2959.077,2518.898z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000140716638697852980230000001352250709458235029_",
    gradientUnits: "userSpaceOnUse",
    x1: 2362.1414,
    y1: 2236.7034,
    x2: 2734.5322,
    y2: 2091.4709
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000140716638697852980230000001352250709458235029_)"
    },
    d: "M2959.077,2518.898 c7.192-0.106,14.345-0.054,21.583-0.378c13.196-0.59,26.46-1.539,39.775-2.864c-2.225-13.85-4.449-27.701-6.674-41.551 c-6.792-2.594-13.426-5.196-19.917-7.807c-3.314-1.334-6.487-2.678-9.724-4.015c-3.054-1.261-6.173-2.52-9.158-3.786 c-4.392-1.863-8.634-3.734-12.881-5.604c-1.688-0.743-3.44-1.482-5.107-2.227c-4.985-2.229-9.826-4.465-14.61-6.701 c-0.807-0.377-1.653-0.754-2.453-1.13c-5.178-2.442-10.22-4.886-15.167-7.336c-0.358-0.179-0.738-0.354-1.096-0.533 c-5.208-2.589-10.288-5.183-15.246-7.778c-0.068-0.037-0.14-0.071-0.209-0.107c-10.086-5.288-19.656-10.59-28.74-15.898l0,0 c-112.573-65.789-149.798-132.584-161.267-185.107c-32.271-147.777,125.739-242.67,84.924-402.92 c-30.755-120.76-160.573-224.162-240.509-200.046c-90.277,27.233-104.422,202.212-113.128,309.895 c-9.801,121.245-20.721,256.319,56.823,377.307c73.427,114.571,206.078,185.074,358.72,203.838 c0,0.008-0.001,0.015-0.001,0.024c3.63,0.445,7.348,0.648,11,1.035c8.851,0.938,17.688,1.917,26.659,2.509 c4.104,0.271,8.28,0.287,12.405,0.485c8.746,0.42,17.472,0.903,26.308,0.994 C2947.248,2519.255,2953.184,2518.982,2959.077,2518.898z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000000945003584013626180000005267871592100060063_",
    gradientUnits: "userSpaceOnUse",
    x1: 2136.9758,
    y1: 1152.09,
    x2: 2447.4763,
    y2: 1447.2191
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000000945003584013626180000005267871592100060063_)"
    },
    d: "M2223.947,1659.94 c-17.258-27.382,63.215-67.778,89.374-180.144c22.088-94.872-22.98-118.906,1.607-245.915 c13.695-70.738,37.07-111.817,64.314-141.637c22.453-24.579,51.622-56.508,77.916-52.334 c82.446,13.091,180.104,388.089,15.361,551.604C2387.867,1675.534,2244.763,1692.966,2223.947,1659.94z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000179636224489163486830000004567054190044845489_",
    gradientUnits: "userSpaceOnUse",
    x1: 2131.2417,
    y1: 3032.6013,
    x2: 2121.2383,
    y2: 3526.637,
    gradientTransform: "matrix(0.9832 -0.1825 0.1825 0.9832 -66.6194 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AB316D"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#792D3D"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000179636224489163486830000004567054190044845489_)"
    },
    d: "M2656.699,2847.272 c-3.748-8.647-24.385,13.084-43.61,36.035c2.476,33.031,4.954,66.063,7.43,99.096c-6.826-4.339-15.433-9.081-25.141-11.323 c-11.667-2.689-31.833,1.51-33.383,7.088c-9.561,34.424,76.281,41.939,85.687,31.125c9.407-10.817,7.256-23.473,7.256-23.473 c-8.713-49.605-7.56-83.2-3.429-106.396C2654.412,2863.131,2658.769,2852.045,2656.699,2847.272z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170249199598501199120000009352975138159055527_",
    gradientUnits: "userSpaceOnUse",
    x1: 2243.4734,
    y1: 2210.2153,
    x2: 2394.9673,
    y2: 2723.6111,
    gradientTransform: "matrix(0.9832 -0.1825 0.1825 0.9832 -66.6194 160.6767)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170249199598501199120000009352975138159055527_)"
    },
    d: "M2876.619,1739.438 c-48.987-72.223-96.737-145.282-144.607-218.247c-9.404-14.336-14.857-30.969-17.479-48.432 c-19.008,15.087-37.212,33.147-53.989,54.276c-13.479,67.584-34.296,169.181-61.761,292.316 c-69.789,312.906-99.165,391.265-113.967,489.691c-22.776,151.43-14.703,374.563,135.704,673.36 c11.473,1.139,22.945,2.278,34.418,3.417c24.177-255.583,51.906-486.259,65.899-604.805 c4.749-40.222,18.76-160.883,83.363-258.072c1.04-1.565,96.632-132.283,129.616-184.509 c10.981-17.387,24.719-39.942,40.332-70.106C2937.111,1829.405,2907.431,1784.862,2876.619,1739.438z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000175313798159797197390000014415777965360381618_",
    gradientUnits: "userSpaceOnUse",
    x1: 2652.0696,
    y1: 1837.6001,
    x2: 2807.1621,
    y2: 2363.1904
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.25,
      fill: "url(#SVGID_00000175313798159797197390000014415777965360381618_)"
    },
    d: "M2876.619,1739.438 c-48.985-72.223-96.738-145.281-144.607-218.248c-9.403-14.337-14.857-30.968-17.479-48.432 c-19.008,15.089-37.212,33.148-53.989,54.28c-21.367,82.629-36.595,153.31-47.257,207.354 c-29.578,149.902-27.895,191.361-6.707,228.581c29.126,51.167,62.666,37.327,83.949,81.859 c37.311,78.077-62.602,131.422-61.684,281.981c0.51,83.484,30.361,104.44,16.771,181.069 c-3.508,19.782-13.453,63.24-9.06,122.941c1.928,26.217,4.042,20.512,5.649,44.202c4.575,67.491-11.523,129.538-4.548,171.688 c2.507,15.149,7.662,25.714,9.663,29.561c5.371,10.322,11.667,17.718,16.095,22.307 c21.91-220.015,45.042-412.685,57.422-517.568c4.749-40.22,18.76-160.882,83.363-258.072 c1.04-1.565,96.632-132.284,129.616-184.512c10.981-17.384,24.719-39.939,40.332-70.104 C2937.111,1829.405,2907.43,1784.861,2876.619,1739.438z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000020399401978037442840000015130381050651982258_",
    gradientUnits: "userSpaceOnUse",
    x1: 2685.4395,
    y1: 1302.9265,
    x2: 3539.8079,
    y2: 1844.3077,
    gradientTransform: "matrix(0.9995 -0.0302 0.0302 0.9995 -235.3357 118.8563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000020399401978037442840000015130381050651982258_)"
    },
    d: "M2369.713,1107.903 c-30.795,56.468-27.287,112.706-23.916,137.321c10.142,74.032,53.394,123.371,67.914,142.026 c48.689,62.551,86.661,186.276,26.223,457.489c33.91-5.442,89.715-10.667,154.739,2.887 c165.385,34.474,231.406,157.284,310.751,134.897c29.296-8.264,69.079-38.767,96.822-152.679 c24.246-59.231,99.798-264.757,22.345-506.453c-55.399-172.87-161.962-279.65-214.75-326.094 c-45.382-15.285-187.083-56.594-321.907,8.694C2454.339,1022.259,2402.152,1048.427,2369.713,1107.903z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M2524.541,1458.133l-126.489-44.674c-2.339-0.749-4.204-2.536-5.051-4.841l-20.973-57.075 c-2.167-5.895,3.022-11.861,9.162-10.535l118.846,25.706c2.719,0.587,8.776,2.347,10.633,7.401l23.532,69.609 C2536.345,1449.927,2530.79,1460.132,2524.541,1458.133z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M2522.602,1458.858l-122.233-39.097c-2.339-0.75-4.204-2.534-5.052-4.841l-20.974-57.074 c-2.167-5.896,3.021-11.864,9.161-10.536l118.847,25.705c2.719,0.589,4.936,2.555,5.846,5.184l24.361,70.469 C2534.703,1454.868,2528.851,1460.858,2522.602,1458.858z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000028318477943384904190000005369549786632219290_",
    gradientUnits: "userSpaceOnUse",
    x1: -996.5547,
    y1: -362.9183,
    x2: -832.1475,
    y2: -362.9183,
    gradientTransform: "matrix(0.8308 0.5567 -0.5567 0.8308 3122.0977 2252.583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000028318477943384904190000005369549786632219290_)"
    },
    d: "M2578.022,1420.672l-13.677-6.495 c0,0-21.504-15.743-35.952-22.087c-14.447-6.344-26.144-4.831-35.099,8.532c-8.957,13.365,6.25,25.935,19.299,36.973 c7.938,6.714,24.491,7.313,37.886,6.6c9.418-0.5,28.26,6.021,28.26,6.021L2578.022,1420.672z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080911352426237689810000009567888161989595799_",
    gradientUnits: "userSpaceOnUse",
    x1: 2466.9602,
    y1: 828.793,
    x2: 2575.9478,
    y2: 1128.5092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#893976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080911352426237689810000009567888161989595799_)"
    },
    d: "M2552.159,884.167 c-0.042,11.932,0.418,75.82,28.805,86.308c6.205,2.293,11.188,0.831,38.713,1.549c15.691,0.409,28.458,1.249,36.679,1.881 c-1.395,10.885-4.137,25.485-9.971,41.901c-35.323,99.393-149.656,168.447-188.39,143.573 c-20.172-12.953-21.728-51.81-22.373-67.933c-0.969-24.217,4.869-43.402,9.131-54.386c14.18-10.3,28.688-20.628,43.527-30.954 c9.693-6.747,19.333-13.362,28.917-19.847c-0.647-12.226-1.295-24.449-1.942-36.675 C2527.558,927.779,2539.859,905.972,2552.159,884.167z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170250095009403094880000008542727251791767187_",
    gradientUnits: "userSpaceOnUse",
    x1: -26.6247,
    y1: 1436.7003,
    x2: -35.0492,
    y2: 1196.6075,
    gradientTransform: "matrix(-0.9786 0.206 0.206 0.9786 2240.5857 -233.1068)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170250095009403094880000008542727251791767187_)"
    },
    d: "M2564.548,907.729 c0,0,0.135,52.578-41.844,69.679c-37.588,15.314-86.887-72.931-72.031-101.568c4.958-9.553,19.794-20.772,34.16-23.367 c10.101-1.824,52.027-2.075,63.906,30.869c3.534-10.414,10.567-17.166,17.834-17.242c1.159-0.014,4.489,0.475,7.148,2.372 C2583.344,875.333,2580.606,891.389,2564.548,907.729z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000181769911903700679730000013593300455329414818_",
    gradientUnits: "userSpaceOnUse",
    x1: 2665.9856,
    y1: 1298.1331,
    x2: 3543.1863,
    y2: 1853.9823,
    gradientTransform: "matrix(0.9995 -0.0302 0.0302 0.9995 -235.3357 118.8563)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000181769911903700679730000013593300455329414818_)"
    },
    d: "M3024.589,1323.392 c-43.343-135.25-117.913-229.864-173.638-286.961c-63.884,42.225-128.876,99.446-123.45,160.798 c6.175,69.815,99.443,98.666,90.733,142.813c-12.626,63.992-215.787,39.752-239.497,110.174 c-27.938,82.988,212.956,239.07,200.073,256.741c-9.216,12.641-120.015-76.675-245.778-55.859 c-24.398,4.037-46.26,13.551-65.736,26.083c-4.478,48.509-13.182,103.929-27.363,167.559 c33.91-5.442,89.715-10.667,154.739,2.887c165.385,34.474,231.406,157.284,310.751,134.897 c29.296-8.264,69.079-38.767,96.822-152.679C3026.49,1770.613,3102.043,1565.087,3024.589,1323.392z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000011005304089487446510000011712490905508609162_",
    gradientUnits: "userSpaceOnUse",
    x1: 2705.6091,
    y1: 1242.2955,
    x2: 3157.4897,
    y2: 1528.6354
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000011005304089487446510000011712490905508609162_)"
    },
    d: "M2719.903,1002.067 c38.395-9.567,38.59-22.053,89.937-4.768c147.45,49.635,303.544,272.16,222.872,429.295 c-44.87,87.398-152.382,166.205-270.915,148.025c-96.491-14.8-153.166-86.647-167.576-106.132 c-5.586-22.343-11.171-44.687-16.757-67.03c62.882,35.647,107.171,35.636,136.853,27.929 c50.524-13.118,61.744-49.323,145.233-80.994c32.526-12.34,52.066-14.904,53.065-25.137 c2.065-21.159-79.711-28.219-131.267-72.616C2743.763,1218.274,2706.268,1152.307,2719.903,1002.067z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054953819257232495420000004323339468501279422_",
    gradientUnits: "userSpaceOnUse",
    x1: 760.5583,
    y1: 3080.2437,
    x2: 789.1669,
    y2: 3104.3008
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054953819257232495420000004323339468501279422_)"
    },
    d: "M868.127,3127.216 c0,37.569-23.151,68.022-51.711,68.022c-28.558,0-51.709-30.454-51.709-68.022c0-37.567,23.151-68.022,51.709-68.022 C844.976,3059.193,868.127,3089.648,868.127,3127.216z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000138569897430217510190000012816548574169504150_",
    gradientUnits: "userSpaceOnUse",
    x1: 779.1108,
    y1: 3127.856,
    x2: 882.5309,
    y2: 3127.856
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000138569897430217510190000012816548574169504150_)"
    },
    d: "M882.531,3127.856 c0,37.569-23.15,68.022-51.709,68.022c-28.559,0-51.711-30.454-51.711-68.022c0-37.567,23.152-68.022,51.711-68.022 C859.381,3059.834,882.531,3090.289,882.531,3127.856z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000017485514056682557150000004216626175995129788_",
    gradientUnits: "userSpaceOnUse",
    x1: 809.1482,
    y1: 3129.2263,
    x2: 852.484,
    y2: 3129.2263
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000017485514056682557150000004216626175995129788_)"
    },
    d: "M852.484,3129.226 c0,15.742-9.701,28.504-21.668,28.504c-11.966,0-21.668-12.761-21.668-28.504c0-15.741,9.702-28.502,21.668-28.502 C842.783,3100.723,852.484,3113.485,852.484,3129.226z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M816.417,3044.828v74.693c0,10.968,8.89,19.858,19.858,19.858l0,0 c6.338,0,12.298-3.027,16.035-8.146l67.179-91.987L816.417,3044.828z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000083078287175023331600000008381940295148123521_",
    gradientUnits: "userSpaceOnUse",
    x1: 1314.1774,
    y1: 3020.5955,
    x2: 1342.786,
    y2: 3044.6526
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000083078287175023331600000008381940295148123521_)"
    },
    d: "M1421.746,3067.567 c0,37.569-23.152,68.024-51.711,68.024c-28.558,0-51.709-30.455-51.709-68.024c0-37.566,23.151-68.022,51.709-68.022 C1398.595,2999.544,1421.746,3030.001,1421.746,3067.567z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000075851371120543966680000014134202436367654042_",
    gradientUnits: "userSpaceOnUse",
    x1: 1332.7314,
    y1: 3068.2092,
    x2: 1436.1514,
    y2: 3068.2092
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000075851371120543966680000014134202436367654042_)"
    },
    d: "M1436.151,3068.208 c0,37.567-23.151,68.024-51.709,68.024c-28.559,0-51.711-30.456-51.711-68.024s23.151-68.022,51.711-68.022 C1413,3000.186,1436.151,3030.641,1436.151,3068.208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000168834257101428900920000010165327825911886737_",
    gradientUnits: "userSpaceOnUse",
    x1: 1362.7687,
    y1: 3069.5789,
    x2: 1406.1031,
    y2: 3069.5789
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000168834257101428900920000010165327825911886737_)"
    },
    d: "M1406.103,3069.578 c0,15.742-9.699,28.504-21.668,28.504c-11.965,0-21.667-12.761-21.667-28.504s9.701-28.502,21.667-28.502 C1396.404,3041.076,1406.103,3053.836,1406.103,3069.578z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1370.036,2985.179v74.695c0,10.966,8.89,19.856,19.858,19.856l0,0 c6.339,0,12.298-3.027,16.036-8.146l67.176-91.987L1370.036,2985.179z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M808.694,3056.435c-6.807,0-12.673-5.118-13.454-12.044c-0.841-7.442,4.516-14.15,11.958-14.99 l655.62-73.879c35.682-6.138,65.438-33.259,75.038-68.98l257.038-1121.031c14.626-54.446,62.24-93.624,118.474-97.498 l199.424-11.892c7.495-0.517,13.898,5.251,14.342,12.726c0.45,7.475-5.25,13.898-12.726,14.342l-199.299,11.885 c-44.567,3.072-82.401,34.205-94.021,77.468l-257.038,1121.031c-12.335,45.912-50.58,80.759-97.425,88.791l-656.395,73.986 C809.714,3056.409,809.204,3056.435,808.694,3056.435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1247.226,2555.388c-5.9,0-11.329-3.886-13.031-9.839l-154.387-540.225 c-2.059-7.204,2.112-14.706,9.309-16.765c7.191-2.053,14.706,2.119,16.765,9.309l154.387,540.225 c2.059,7.204-2.112,14.706-9.31,16.765C1249.716,2555.216,1248.458,2555.388,1247.226,2555.388z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1405.169,2532.797c-6.449,0-12.17-4.615-13.335-11.183l-95.226-535.134 c-1.311-7.376,3.602-14.414,10.971-15.725c7.442-1.344,14.421,3.602,15.725,10.971l95.226,535.134 c1.311,7.376-3.602,14.414-10.971,15.725C1406.751,2532.73,1405.957,2532.797,1405.169,2532.797z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1503.302,2515.257c-0.185,0-0.377-0.007-0.569-0.013c-7.482-0.311-13.295-6.628-12.984-14.11 l21.976-529.472c0.305-7.482,6.297-13.421,14.11-12.984c7.482,0.311,13.296,6.628,12.984,14.11l-21.976,529.473 C1516.544,2509.55,1510.532,2515.257,1503.302,2515.257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M1031.798,2575.153c-5.668,0-10.952-3.582-12.858-9.256l-181.269-540.464 c-2.377-7.098,1.443-14.785,8.548-17.169c7.098-2.364,14.785,1.443,17.169,8.548l181.269,540.464 c2.377,7.098-1.443,14.785-8.548,17.169C1034.678,2574.921,1033.229,2575.153,1031.798,2575.153z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000005260978706728896070000006723798210099789471_",
    gradientUnits: "userSpaceOnUse",
    x1: 2105.9846,
    y1: 1684.8088,
    x2: 2606.4043,
    y2: 1684.8088
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000005260978706728896070000006723798210099789471_)"
    },
    d: "M2579.316,1730.272 c-0.748,0-1.497-0.027-2.258-0.093l-446.177-36.682c-14.924-1.225-26.035-14.322-24.803-29.253 c1.225-14.931,14.335-26.054,29.252-24.803l446.177,36.682c14.924,1.225,26.035,14.322,24.803,29.252 C2605.146,1719.546,2593.287,1730.272,2579.316,1730.272z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052096115747635970790000016045726812235086742_",
    gradientUnits: "userSpaceOnUse",
    x1: 1228.6802,
    y1: 3167.2195,
    x2: 1257.2887,
    y2: 3191.2769
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052096115747635970790000016045726812235086742_)"
    },
    d: "M1336.249,3214.192 c0,37.567-23.151,68.022-51.709,68.022c-28.561,0-51.711-30.455-51.711-68.022s23.15-68.022,51.711-68.022 C1313.098,3146.169,1336.249,3176.625,1336.249,3214.192z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000008856349541337352040000000224649153369660333_",
    gradientUnits: "userSpaceOnUse",
    x1: 1247.2328,
    y1: 3214.833,
    x2: 1350.6528,
    y2: 3214.833
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000008856349541337352040000000224649153369660333_)"
    },
    d: "M1350.653,3214.832 c0,37.567-23.15,68.024-51.709,68.024c-28.558,0-51.711-30.457-51.711-68.024c0-37.567,23.153-68.022,51.711-68.022 C1327.503,3146.81,1350.653,3177.265,1350.653,3214.832z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000145750346620612507270000005129720795438334140_",
    gradientUnits: "userSpaceOnUse",
    x1: 1277.2701,
    y1: 3216.2024,
    x2: 1320.6062,
    y2: 3216.2024
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000145750346620612507270000005129720795438334140_)"
    },
    d: "M1320.606,3216.202 c0,15.742-9.7,28.503-21.668,28.503c-11.966,0-21.668-12.761-21.668-28.503c0-15.741,9.702-28.502,21.668-28.502 C1310.906,3187.699,1320.606,3200.461,1320.606,3216.202z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1284.54,3131.804v74.692c0,10.968,8.89,19.858,19.856,19.858l0,0 c6.339,0,12.298-3.027,16.036-8.147l67.177-91.986L1284.54,3131.804z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000176043451781048254970000007199388059697134999_",
    gradientUnits: "userSpaceOnUse",
    x1: 1707.9962,
    y1: 3119.2351,
    x2: 1736.6049,
    y2: 3143.2922
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000176043451781048254970000007199388059697134999_)"
    },
    d: "M1815.565,3166.208 c0,37.567-23.151,68.022-51.709,68.022c-28.559,0-51.71-30.455-51.71-68.022c0-37.569,23.151-68.022,51.71-68.022 C1792.413,3098.185,1815.565,3128.639,1815.565,3166.208z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000013176198019090148510000003207056302947856768_",
    gradientUnits: "userSpaceOnUse",
    x1: 1726.5499,
    y1: 3166.8479,
    x2: 1829.9701,
    y2: 3166.8479
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#AA80F9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#6165D7"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000013176198019090148510000003207056302947856768_)"
    },
    d: "M1829.97,3166.848 c0,37.569-23.152,68.022-51.709,68.022s-51.711-30.454-51.711-68.022c0-37.567,23.153-68.022,51.711-68.022 S1829.97,3129.281,1829.97,3166.848z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000183239392725922010550000004958708583362625430_",
    gradientUnits: "userSpaceOnUse",
    x1: 1756.5872,
    y1: 3168.2168,
    x2: 1799.9218,
    y2: 3168.2168
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000183239392725922010550000004958708583362625430_)"
    },
    d: "M1799.922,3168.218 c0,15.741-9.7,28.502-21.667,28.502c-11.967,0-21.668-12.761-21.668-28.502c0-15.742,9.701-28.504,21.668-28.504 C1790.222,3139.714,1799.922,3152.475,1799.922,3168.218z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1763.855,3083.82v74.693c0,10.968,8.89,19.859,19.856,19.859l0,0 c6.341,0,12.298-3.028,16.038-8.147l67.176-91.987L1763.855,3083.82z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M587.124,2047.071c-7.045,0-12.997-5.449-13.514-12.587c-0.536-7.469,5.085-13.964,12.554-14.5 l1167.659-84.05c1.093-0.053,2.178-0.026,3.251,0.159l483.395,82.335c7.383,1.258,12.349,8.263,11.091,15.646 c-1.258,7.376-8.17,12.349-15.646,11.091l-481.78-82.063L588.11,2047.038C587.779,2047.057,587.448,2047.071,587.124,2047.071z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C2C2C2"
    },
    d: "M2087.161,2593.725c-0.689,0-1.377-0.053-2.079-0.159l-475.668-72.979l-723.679,69.655 c-7.449,0.702-14.083-4.754-14.798-12.203c-0.715-7.456,4.747-14.077,12.203-14.798l725.361-69.814 c1.106-0.106,2.251-0.08,3.357,0.099l477.344,73.237c7.402,1.132,12.481,8.058,11.342,15.46 C2099.516,2588.925,2093.736,2593.725,2087.161,2593.725z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000166640261286924364250000017785786576682450565_",
    gradientUnits: "userSpaceOnUse",
    x1: 1030.3125,
    y1: 1733.3528,
    x2: 1371.7203,
    y2: 1718.509
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000166640261286924364250000017785786576682450565_)"
    },
    d: "M1604.266,1877.568 c-4.729,1.044-9.238-3.038-9.899-7.666c-11.816-82.786-45.578-172.922-94.359-235.026 c-43.659-55.583-77.332-79.688-141.013-90.735c-0.071-0.013,0.235,5.192,0.193,5.187 c-133.704-14.221-142.8,292.391-141.679,335.487c1.812,69.734-3.756,15.532-9.089,21.404 c-5.332,5.871-9.424,26.215-10.458-10.798c-2.754-98.51,8.277-358.855,159.209-370.038c0.052-0.004-0.253-1.78-0.164-1.768 c71.666,9.66,110.135,36.505,158.768,97.97c50.998,64.454,85.85,157.033,97.208,243.176c0.65,4.936-2.502,11.285-7.768,12.587 C1604.905,1877.426,1604.562,1877.502,1604.266,1877.568z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007430472402029235320000004001015932403809968_",
    gradientUnits: "userSpaceOnUse",
    x1: 958.1313,
    y1: 2263.4395,
    x2: 1328.3741,
    y2: 2263.4395
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007430472402029235320000004001015932403809968_)"
    },
    d: "M986.5,2596.519 c71.898,24.984,159.423,37.418,234.102,63.178c26.097-113.693,71.45-223.409,107.772-334.082 c-70.054-152.618-129.637-310-208.435-458.432c-18.506,5.26-36.691,10.401-55.424,15.726 c-7.556,248.108-57.409,442.173-105.5,679.113C954.892,2582.328,965.396,2589.184,986.5,2596.519z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000122721797228281505190000015377292572221538479_",
    gradientUnits: "userSpaceOnUse",
    x1: 1080.7457,
    y1: 2263.4226,
    x2: 1328.3615,
    y2: 2263.4226
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "url(#SVGID_00000122721797228281505190000015377292572221538479_)"
    },
    d: "M1328.361,2325.618 c-70.025-152.642-129.63-309.97-208.424-458.458c-10.785,3.87-21.833,4.63-32.45,10.532 c0.187,33.585,7.123,123.501,10.435,148.92c13.868,106.469,55.315,211.739,40.051,306.925 c-12.488,77.881-57.338,99.636-57.228,170.03c0.12,75.895,63.601,118.154,124.63,151.5c5.794,1.437,10.228,2.94,15.436,4.619 C1246.414,2546.022,1292.197,2436.269,1328.361,2325.618z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000091705431788862210630000006130483962333323164_",
    gradientUnits: "userSpaceOnUse",
    x1: 1500.2103,
    y1: 2202.459,
    x2: 2033.842,
    y2: 3101.5476
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000091705431788862210630000006130483962333323164_)"
    },
    d: "M1119.939,1867.183 c247.268,3.441,458.335-13.423,701.672-51.197c104.31,259.517,175.742,506.141,253.735,773.326 c-273.518,11.015-585.907,26.93-854.541,70.374C1159.336,2409.179,1173.333,2124.409,1119.939,1867.183z"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.3
    }
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000112611125195861585830000010580403594272070585_",
    gradientUnits: "userSpaceOnUse",
    x1: 1492.7169,
    y1: 2117.3726,
    x2: 1927.5157,
    y2: 3138.4919
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFC444"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#F36F56"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000112611125195861585830000010580403594272070585_)"
    },
    d: "M1821.612,1815.999 c-121.886,18.612-230.796,32.304-356.695,41.581c-19.548,1.44-14.583,31.323-13.672,52.802 c5.343,125.687,240.352,120.99,276.798,270.263c27.214,111.469-86.914,241.338-171.398,290.651 c-88.247,51.508-168.068,31.371-238.863,90.484c-30.888,25.791-41.51,54.695-54.151,91.365 c258.083-36.963,550.135-53.401,811.724-63.834C1997.715,2321.939,1925.377,2075.629,1821.612,1815.999z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000170992407043834268310000014292308507662531470_",
    gradientUnits: "userSpaceOnUse",
    x1: 1541.813,
    y1: 1421.0643,
    x2: 1391.5436,
    y2: 2703.7234
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000170992407043834268310000014292308507662531470_)"
    },
    d: "M1346.945,1922.173 c-10.123-19.33,0.795,29.129-11.647-13.673c-23.539-80.971-60.32-222.247-12.371-316.093 c13.888-27.183,45.941-52.105,76.057-59.974c155.205-40.55,261.866,216.098,296.274,317.297 c11.59,34.09,1.78,18.958-6.01,13.224c-7.79-5.733,9.652,56.406-15.711-15.724c-17.586-50.012-135.753-347.833-268.816-293.257 c-24.287,9.961-49.876,31.771-63.345,49.009c-51.088,65.377,0.664,260.628,8.539,288.104 c20.625,71.967-3.612,0.662-0.703,30.964C1349.626,1926.373,1348.633,1925.397,1346.945,1922.173z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000127030766681886617660000005271068571855566756_",
    gradientUnits: "userSpaceOnUse",
    x1: 1621.8192,
    y1: 1402.1141,
    x2: 1213.4728,
    y2: 2178.967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000127030766681886617660000005271068571855566756_)"
    },
    d: "M1373.734,1922.425 c1.151,15.091-9.037,28.194-24.386,29.212c-15.349,1.018-27.013-10.847-28.159-25.84c-1.148-14.993,8.745-28.108,24.086-28.972 C1360.613,1895.961,1372.584,1907.333,1373.734,1922.425z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104693781716400357670000010960211715233114296_",
    gradientUnits: "userSpaceOnUse",
    x1: 1905.1646,
    y1: 1473.2534,
    x2: 1465.3711,
    y2: 2309.9321
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#40447E"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    style: {
      stopColor: "#3C3B6B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104693781716400357670000010960211715233114296_)"
    },
    d: "M1719.123,1869.997 c0.743,15.166-8.985,29.96-23.937,33.731c-14.951,3.773-26.451-7.38-27.274-22.325c-0.822-14.944,9.314-29.754,24.394-32.578 C1707.387,1846.003,1718.381,1854.831,1719.123,1869.997z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D8DEE8"
    },
    d: "M1911.948,2204.285c-74.516-69.945-157.039-136.718-238.088-199.284 c-6.946-5.362-10.491-4.67-17.432-0.392c-34.982,21.562-76.638,44.447-111.186,65.17c-11.598,6.957-14.481,15.841-5.379,26.846 c66.609,80.543,137.411,164.419,202.403,246.625c7.037,8.901,14.046,9.403,23.329,2.524 c47.399-35.127,100.81-74.892,145.484-113.193C1921.572,2223.583,1922.215,2213.922,1911.948,2204.285z M1647.94,2083.844 c-8.73,7.577-20.057,1.314-26.237-6.8c-6.181-8.115-9.492-20.994-0.997-28.785c8.496-7.792,19.832-1.634,25.995,6.469 C1652.863,2062.832,1656.669,2076.268,1647.94,2083.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4F7FA"
    },
    d: "M1911.861,2201.264c-74.521-70.024-157.151-136.528-238.286-199.194 c-6.954-5.37-10.396-4.554-17.344-0.288c-35.01,21.492-76.551,44.508-111.129,65.216c-11.607,6.952-14.527,15.762-5.419,26.776 c66.66,80.614,137.491,164.439,202.558,246.705c7.045,8.908,14.035,9.383,23.318,2.494 c47.403-35.187,100.782-75.05,145.427-113.445C1921.471,2220.51,1922.13,2210.912,1911.861,2201.264z M1647.744,2080.958 c-8.719,7.572-20.049,1.348-26.217-6.757c-6.168-8.105-9.507-21.037-1.047-28.856s19.835-1.627,25.992,6.469 S1656.465,2073.386,1647.744,2080.958z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M1599.418,2036.602c-0.71,0.146-1.565-0.413-1.981-1.11 c-8.642-14.523-19.37-30.299-32.854-40.051c-37.122-26.847-79.164-28.683-122.155-30.3 c-42.99-1.616-78.217-4.458-109.225-34.888c-7.967-7.817-16.098-19.484-12.63-30.36c1.386-4.35,7.657-4.537,11.66-4.87 c0.784-0.065,2.076,0.911,2.181,2.213c0.106,1.303-1.446,1.857-2.007,2.22c-2.125,1.374-8.117-1.582-8.207,3.124 c-0.191,9.875,2.586,15.637,13.071,25.738c27.543,26.537,64.26,31.577,105.57,32.465c42.988,0.924,87.017,3.836,124.458,31.01 c13.639,9.899,25.188,26.456,33.902,41.37c0.555,0.95-0.01,2.659-0.762,3.063 C1599.685,2036.632,1600.129,2036.455,1599.418,2036.602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#26264F"
    },
    d: "M1620.436,2068.886c-1.323,1.325-1.461,1.187-1.693-0.543c-0.231-1.729-2.939,2.328,0.623-4.272 c3.561-6.599,15.243-20.97,10.586-36.684c-2.867-9.672-2.439-20.154-19.762-31.028c-37.114-23.297-95.214-38.91-141.399-52.58 c-28.294-8.374-59.966-19.039-87.211-30.532c-6.178-2.606-9.796-4.096-15.547-6.178c-1.239-0.449-1.693-1.626-1.32-2.786 c0.375-1.16,1.42-1.823,2.665-1.4c5.923,2.01,9.59,3.627,15.913,6.278c26.999,11.324,58.802,22.056,86.864,30.282 c46.242,13.553,105.5,29.706,142.619,53.058c18.354,11.547,18.389,23.539,21.462,34.1c4.952,17.023-7.709,33.294-11.546,40.19 C1618.853,2073.689,1621.759,2067.561,1620.436,2068.886z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M1911.868,2201.287c-74.608-70.284-157.075-136.184-238.296-199.412 c-6.96-5.419-10.488-2.851-17.244-0.494c-3.043,1.062-6.683,4.564-9.801,6.037c3.615,9.998,9.551,21.726,15.297,29.898 c29.734,42.295,87.592,44.062,104.715,87.77c15.088,38.51-21.806,66.881-23.397,112.949 c-0.79,22.886,13.863,73.534,35.424,94.951c43.953-32.074,91.854-68.142,132.441-103.454 C1921.469,2220.429,1922.147,2210.971,1911.868,2201.287z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M983.887,2167.531c-1.331,0-2.662-0.199-3.94-0.583l-396.75-120.46 c-7.164-2.178-11.21-9.753-9.038-16.917c2.185-7.164,9.793-11.19,16.917-9.038l394.174,119.678l1251.622-121.91 c7.574-0.814,14.09,4.728,14.812,12.176c0.729,7.455-4.728,14.09-12.176,14.812L985.205,2167.464 C984.761,2167.511,984.324,2167.531,983.887,2167.531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1224.668,2675.729c-5.198,0-9.991-2.986-12.249-7.753l-240.787-508.198 c-3.205-6.767-0.318-14.851,6.449-18.063c6.76-3.191,14.858-0.324,18.063,6.449l236.715,499.604l852.999-81.103 c7.562-0.715,14.077,4.767,14.785,12.216c0.708,7.456-4.761,14.077-12.216,14.785l-862.467,82.004 C1225.528,2675.709,1225.098,2675.729,1224.668,2675.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1224.688,2675.729c-1.099,0-2.205-0.132-3.317-0.41l-340.238-85.427 c-3.661-0.92-6.78-3.324-8.594-6.641l-297.299-543.231c-3.595-6.568-1.179-14.812,5.39-18.407 c6.575-3.582,14.812-1.172,18.407,5.39l294.452,538.034l334.491,83.984c7.264,1.821,11.673,9.19,9.846,16.454 C1236.281,2671.624,1230.753,2675.729,1224.688,2675.729z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1071.466,2352.375c-1.291,0-2.576-0.185-3.814-0.549L693.99,2242.304 c-7.184-2.105-11.302-9.64-9.197-16.824c2.099-7.184,9.674-11.309,16.825-9.197l371.212,108.8l1103.373-96.226 c7.588-0.748,14.037,4.873,14.686,12.329c0.656,7.462-4.867,14.037-12.329,14.686l-1105.916,96.451 C1072.254,2352.355,1071.857,2352.375,1071.466,2352.375z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1162.759,2545.046c-1.232,0-2.463-0.165-3.655-0.503l-357.976-100.285 c-7.217-2.02-11.422-9.501-9.402-16.712c2.02-7.217,9.501-11.435,16.712-9.402l355.599,99.616l958.124-83.818 c7.442-0.788,14.037,4.867,14.686,12.329c0.656,7.455-4.867,14.037-12.329,14.686l-960.58,84.036 C1163.547,2545.026,1163.15,2545.046,1162.759,2545.046z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1400.786,2658.99c-5.84,0-11.236-3.807-12.991-9.693l-153.559-515.184 c-2.139-7.177,1.947-14.732,9.124-16.871c7.151-2.145,14.726,1.94,16.871,9.124l153.559,515.184 c2.139,7.177-1.947,14.732-9.124,16.871C1403.375,2658.805,1402.07,2658.99,1400.786,2658.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1570.646,2642.835c-6.462,0-12.183-4.628-13.342-11.203l-92.101-521.951 c-1.298-7.376,3.622-14.408,10.998-15.712c7.349-1.284,14.414,3.628,15.712,10.998l92.101,521.951 c1.298,7.376-3.622,14.408-10.998,15.712C1572.222,2642.769,1571.428,2642.835,1570.646,2642.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1762.225,2621.031c-7.144,0-13.123-5.582-13.527-12.799l-29.028-518.263 c-0.417-7.482,5.304-13.885,12.779-14.302c7.528-0.291,13.885,5.303,14.302,12.779l29.028,518.263 c0.417,7.482-5.304,13.885-12.779,14.302C1762.741,2621.024,1762.483,2621.031,1762.225,2621.031z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1943.752,2600.711c-0.238,0-0.483-0.007-0.722-0.02c-7.482-0.391-13.223-6.773-12.832-14.249 l27.617-526.533c0.391-7.475,6.701-13.216,14.249-12.832c7.482,0.391,13.223,6.774,12.832,14.249l-27.617,526.533 C1956.902,2595.096,1950.916,2600.711,1943.752,2600.711z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1121.781,2649.893c-5.045,0-9.892-2.827-12.229-7.681L861.368,2126.36 c-3.251-6.747-0.411-14.852,6.336-18.096c6.74-3.238,14.858-0.404,18.102,6.337l248.183,515.853 c3.251,6.747,0.411,14.851-6.337,18.102C1125.76,2649.463,1123.754,2649.893,1121.781,2649.893z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M983.9,2615.271c-4.979,0-9.773-2.748-12.143-7.502l-263.452-527.731 c-3.35-6.701-0.629-14.845,6.072-18.188c6.714-3.364,14.858-0.623,18.188,6.072l263.452,527.731 c3.35,6.701,0.629,14.845-6.072,18.188C987.999,2614.814,985.933,2615.271,983.9,2615.271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#999999"
    },
    d: "M1281.941,3152.689c-1.708,0-3.403-0.325-4.999-0.954l-473.227-96.253 c-6.966-2.768-10.369-10.647-7.608-17.606c2.761-6.966,10.654-10.369,17.606-7.608l470.016,94.982l592.083-72.33 c42.144-5.145,76.661-34.927,87.943-75.859l324.566-1178.299c14.812-53.777,62.14-92.618,117.772-96.65l172.211-12.488 c7.389-0.43,13.964,5.072,14.507,12.547c0.536,7.469-5.078,13.964-12.547,14.507l-172.211,12.488 c-44.21,3.198-81.819,34.059-93.591,76.799l-324.566,1178.299c-14.209,51.573-57.697,89.088-110.799,95.577l-595.513,72.747 C1283.04,3152.656,1282.491,3152.689,1281.941,3152.689z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000078734055241645609310000000267000053023789718_",
    gradientUnits: "userSpaceOnUse",
    x1: 2258.7097,
    y1: 1578.1509,
    x2: 2204.946,
    y2: 1661.2405
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#311944"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#A03976"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000078734055241645609310000000267000053023789718_)"
    },
    d: "M2265.143,1655.751 c-4.286-0.148-64.013-1.829-69.69,15.847c-1.611,5.012-0.133,9.987-0.133,9.987c3.134,10.548,16.251,14.168,18.155,14.664 c-20.087,12.851-44.307,9.401-55.859-4.888c-8.087-10.003-10.429-25.884-4.012-38.084c5.941-11.298,17.186-15.681,23.562-17.775 C2221.853,1620.839,2265.143,1655.751,2265.143,1655.751z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCart);
export default __webpack_public_path__ + "static/media/empty-cart.afab6a8015ced9de05df58156e5b4fb6.svg";
export { ForwardRef as ReactComponent };